/**
 * @generated SignedSource<<05b5b5e31b9dd2dc7bbdb8082ce8205a>>
 * @relayHash ca22a2eb34d5852fcd107b884cd9944a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca22a2eb34d5852fcd107b884cd9944a

import type { ConcreteRequest } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "%future added value";
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type IssueFieldUpdateOperation = "ADD" | "CLEAR" | "REMOVE" | "SET" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssueInput = {
  agentAssignment?: AgentAssignmentInput | null | undefined;
  assigneeIds?: ReadonlyArray<string> | null | undefined;
  assignees?: ReadonlyArray<AssigneeUpdateInput> | null | undefined;
  body?: string | null | undefined;
  bodyVersion?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  id: string;
  issueFieldUpdates?: ReadonlyArray<IssueFieldUpdateInput> | null | undefined;
  issueType?: IssueTypeUpdateInput | null | undefined;
  issueTypeId?: string | null | undefined;
  labelIds?: ReadonlyArray<string> | null | undefined;
  labels?: ReadonlyArray<LabelUpdateInput> | null | undefined;
  milestoneId?: string | null | undefined;
  projectIds?: ReadonlyArray<string> | null | undefined;
  projectV2Ids?: ReadonlyArray<string> | null | undefined;
  state?: IssueState | null | undefined;
  stateInput?: IssueStateUpdateInput | null | undefined;
  title?: string | null | undefined;
};
export type AgentAssignmentInput = {
  baseRef?: string | null | undefined;
  customAgent?: string | null | undefined;
  customInstructions?: string | null | undefined;
  model?: string | null | undefined;
  targetRepositoryId?: string | null | undefined;
};
export type AssigneeUpdateInput = {
  actorId: string;
  confidence?: IssueEventConfidenceLevel | null | undefined;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type IssueFieldUpdateInput = {
  fieldName: string;
  operation: IssueFieldUpdateOperation;
  value?: string | null | undefined;
};
export type IssueTypeUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  issueTypeId?: string | null | undefined;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type LabelUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  labelId: string;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type IssueStateUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  duplicateIssueId?: string | null | undefined;
  rationale?: string | null | undefined;
  stateReason?: IssueClosedStateReason | null | undefined;
  suggest?: boolean | null | undefined;
  value: IssueState;
};
export type updateIssueBodyMutation$variables = {
  input: UpdateIssueInput;
};
export type updateIssueBodyMutation$data = {
  readonly updateIssue: {
    readonly issue: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly id: string;
      readonly lastEditedAt: string | null | undefined;
      readonly lastUserContentEdit: {
        readonly editor: {
          readonly login: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined;
      readonly viewerCanReadUserContentEdits: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueBodyMutation$rawResponse = {
  readonly updateIssue: {
    readonly issue: {
      readonly body: string;
      readonly bodyHTML: string;
      readonly bodyVersion: string;
      readonly id: string;
      readonly lastEditedAt: string | null | undefined;
      readonly lastUserContentEdit: {
        readonly editor: {
          readonly __typename: string;
          readonly id: string;
          readonly login: string;
          readonly url: string;
        } | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly viewerCanReadUserContentEdits: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueBodyMutation = {
  rawResponse: updateIssueBodyMutation$rawResponse;
  response: updateIssueBodyMutation$data;
  variables: updateIssueBodyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReadUserContentEdits",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastEditedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueBodyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateIssuePayload",
        "kind": "LinkedField",
        "name": "updateIssue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserContentEdit",
                "kind": "LinkedField",
                "name": "lastUserContentEdit",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "editor",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      (v9/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "updateIssueBodyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateIssuePayload",
        "kind": "LinkedField",
        "name": "updateIssue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserContentEdit",
                "kind": "LinkedField",
                "name": "lastUserContentEdit",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "editor",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ca22a2eb34d5852fcd107b884cd9944a",
    "metadata": {},
    "name": "updateIssueBodyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "56a19899ecaccf4589542aadc2b6144f";

export default node;
